import React from 'react';

import { SelectProps } from 'antd';

import Select from 'components/lib/Select';

import CreateEditActionPlansModalOwnerLabel from './CreateEditActionPlansModalOwnerLabel';
import {
  CreateEditActionPlansModalSelect,
  CreateEditActionPlansModalSelectOptionLabel,
} from './CreateEditActionPlansModalSelectStyles';
import { OwnerOption } from './CreateEditActionPlansModalTypes';

type Props = SelectProps & {
  ownerOptions: OwnerOption[];
  placeholder: React.ReactNode;
  suffixIcon?: React.ReactNode;
};

const CreateEditActionPlansModalOwnerSelect = ({ ownerOptions, placeholder, suffixIcon, ...selectProps }: Props) => {
  const suffixIconProps = suffixIcon !== undefined ? { suffixIcon } : {};

  return (
    <CreateEditActionPlansModalSelect
      allowClear
      className="rectangular"
      filterOption={(inputValue, option) =>
        String(option?.searchText ?? '')
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      }
      labelRender={({ label }) => <CreateEditActionPlansModalOwnerLabel label={label} />}
      optionFilterProp="searchText"
      optionLabelProp="label"
      placeholder={placeholder ?? 'Search users'}
      showSearch
      {...selectProps}
      {...suffixIconProps}
    >
      {ownerOptions.map((ownerOption) => {
        const searchText = [ownerOption.label, ownerOption.role, ownerOption.email].filter(Boolean).join(' ');

        return (
          <Select.Option
            key={ownerOption.value}
            value={ownerOption.value}
            label={ownerOption.label}
            searchText={searchText}
          >
            <CreateEditActionPlansModalSelectOptionLabel>
              <CreateEditActionPlansModalOwnerLabel
                label={ownerOption.label}
                email={ownerOption.email}
                role={ownerOption.role}
                showDetails
              />
            </CreateEditActionPlansModalSelectOptionLabel>
          </Select.Option>
        );
      })}
    </CreateEditActionPlansModalSelect>
  );
};

export default CreateEditActionPlansModalOwnerSelect;
